import { atom, selector } from 'recoil';
import { recoilPersist } from 'recoil-persist';

import { SelectableArray } from '@type-def_common/SelectableArray';

import { CommissionRateTypeKey, CompanyType } from '@constants_iqfu';

const { persistAtom } = recoilPersist();

export type CompanySerivces =
  | 'iqfu'
  | 'cloud'
  | 'pro'
  | 'financial_consulting'
  | 'seller_chat'
  | 'leaseback'
  | 'embed_map'
  | 'selling_page'
  | 'general_company_purchase_company_chat'
  | 'ai_appraisal';

export type CompanyUserData = {
  id: number;
  name: string;
  email: string;
  companies: number[];
  company_details: { id: number; name: string }[];
  services: CompanySerivces[];
  company_type: keyof typeof CompanyType;
  commission_rate_type_key: keyof typeof CommissionRateTypeKey;
};

export const companyLoginUserDataAtom = atom<CompanyUserData | undefined>({
  key: 'companyLoginUserDataAtom',
  default: undefined,
  effects_UNSTABLE: [persistAtom],
});

export const companyLoginUserDataSelector = selector({
  key: 'companyLoginUserDataSelector',
  get: ({ get }) => {
    const companiesData = get(companyLoginUserDataAtom)?.companies;
    const companyId = companiesData?.[0];
    const isMultipleCompanyUser = companiesData && companiesData?.length > 1;
    const companyDetails = get(companyLoginUserDataAtom)?.company_details || [];
    const multipleCompaniesOptions: SelectableArray = companyDetails.reduce((result, { id, name }) => {
      result[id] = name;
      return result;
    }, {} as SelectableArray);
    const companyType = get(companyLoginUserDataAtom)?.company_type as keyof typeof CompanyType;
    const commissionRateTypeKey = get(companyLoginUserDataAtom)
      ?.commission_rate_type_key as keyof typeof CommissionRateTypeKey;

    return {
      companyId,
      isMultipleCompanyUser,
      multipleCompaniesOptions,
      companyType,
      commissionRateTypeKey,
    };
  },
});
